const cultures = {
	en: 'en-US',
	ar: 'ar-AE',
};

export { cultures };
